// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5479) return "static/chunks/795d4814-bda5e5619748b349.js";
	if (chunkId === 3063) return "static/chunks/3063-ce40880085e79855.js";
	if (chunkId === 4850) return "static/chunks/4850-1b651fd327c1706c.js";
	if (chunkId === 4809) return "static/chunks/4809-2d01b59eea28cd48.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2084 ? "9b0008ae" : chunkId) + "." + {"2084":"ed249870d8e74ca0","3464":"ecf6cdb6dcedc315","7699":"a46b98686e0bf29b","8203":"5fe5956f19c9fadd","9257":"d0a8fce9779393fc"}[chunkId] + ".js";
};